import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
// Inter font (self-hosted via @fontsource)
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
// True italic (e.g. the "— (Apex Post)" label) — avoids a synthesized oblique.
import '@fontsource/inter/400-italic.css';
import './index.css';
import App from './App';
import { store } from './app/store';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
